













































import Vue, { PropType } from 'vue';
import { mapActions, mapState } from 'vuex';
import { VueAgile } from 'vue-agile';
import { ICategory } from '@/services/asset';
import { IAssetManagerItem } from '@/composers/asset-manager';
import FullscreenButton from '@/components/FullscreenButton.vue';
import AMR from './AssetManagerRegion.vue';

// TODO: make composed elements Vue TS compatible
const AssetManagerRegion: any = AMR;

interface RecordType {
  type: ICategory;
  type_id: string;
}

export default Vue.extend({
  props: {
    assets: {
      type: Array as PropType<IAssetManagerItem[]>,
      default: () => [],
    },
    record: {
      type: Object as PropType<RecordType>,
    },
    widthRef: String,
  },
  mounted() {
    window.addEventListener('resize', this.resize);
    this.$nextTick(this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
  data: () => ({
    slideshowWidth: 0,
  }),
  computed: mapState(['isMobile']),
  methods: {
    ...mapActions('chromeEditor', [
      'selectPanel',
    ]),
    resize() {
      const widthRef = document.querySelector(this.widthRef);
      if (widthRef) {
        this.slideshowWidth = widthRef.clientWidth;
      }
    },
  },
  components: {
    AssetManagerRegion,
    FullscreenButton,
    VueAgile,
  },
});
